const ACTIONS = {
    CIVIL_CODE_DISCLAIMER_CLICKED: 'LISTING_PAGE/CIVIL_CODE_DISCLAIMER_CLICKED',
    INQUIRY_CLICKED: 'LISTING_PAGE/INQUIRY_CLICKED',
    VIEW_PRICE_DETAILS_CLICKED: 'LISTING_PAGE/VIEW_PRICE_DETAILS_CLICKED',
    PROCESS_SERVER_SIDE_EVALUATED_TESTS: 'LISTING_PAGE/PROCESS_SERVER_SIDE_EVALUATED_TESTS',
    ENTER_DATES_TIMER_COMPLETE: 'LISTING_PAGE/ENTER_DATES_TIMER_COMPLETE',
    TYPEAHEAD_INPUT_FOCUSED: 'LISTING_PAGE/TYPEAHEAD_INPUT_FOCUSED',
    TRIGGER_URGENCY_TOAST: 'LISTING_PAGE/TRIGGER_URGENCY_TOAST',
    LOG_PRICE_SUMMARY_EVENT: 'LISTING/LOG_PRICE_SUMMARY_EVENT',
    SHOW_PROPERTY_DESCRIPTION_DISCLAIMER: 'LISTING_PAGE/SHOW_PROPERTY_DESCRIPTION_DISCLAIMER',
    TRANSLATE_PROPERTY_DESCRIPTION: 'LISTING_PAGE/TRANSLATE_PROPERTY_DESCRIPTION',
    PRIMARY_ACTION_RENDERED: 'LISTING/PRIMARY_ACTION_RENDERED',
    TRANSLATE_PROPERTY_DESCRIPTION_FAILURE: 'LISTING_PAGE/TRANSLATE_PROPERTY_DESCRIPTION_FAILURE'
};

const ACTION_CREATORS = {
    viewPriceDetailsClicked(actionLocation) {
        return {
            type: ACTIONS.VIEW_PRICE_DETAILS_CLICKED,
            payload: {
                actionLocation
            }
        };
    },
    inquiryClicked(actionLocation) {
        return {
            type: ACTIONS.INQUIRY_CLICKED,
            payload: {
                actionLocation
            }
        };
    },
    processServerSideEvaluatedTests() {
        return {
            type: ACTIONS.PROCESS_SERVER_SIDE_EVALUATED_TESTS,
            payload: {}
        };
    },
    enterDatesTimerComplete(enterDatesTimerComplete) {
        return {
            type: ACTIONS.ENTER_DATES_TIMER_COMPLETE,
            payload: {
                enterDatesTimerComplete
            }
        };
    },
    isTypeaheadInputFocused(isFocused) {
        return {
            type: ACTIONS.TYPEAHEAD_INPUT_FOCUSED,
            payload: {isFocused}
        };
    },
    triggerUrgencyToast(element) {
        return {
            type: ACTIONS.TRIGGER_URGENCY_TOAST,
            payload: {
                element
            }
        };
    },
    logPriceSummaryEvent(priceSummaryEventParams) {
        return {
            type: ACTIONS.LOG_PRICE_SUMMARY_EVENT,
            payload: {
                priceSummaryEventParams
            }
        };
    },
    civilCodeDisclaimerClicked(actionLocation) {
        return {
            type: ACTIONS.CIVIL_CODE_DISCLAIMER_CLICKED,
            payload: {
                actionLocation
            }
        };
    },
    showPartnerDescriptionDisclaimer(showDescriptionDisclaimerControl) {
        return {
            type: ACTIONS.SHOW_PROPERTY_DESCRIPTION_DISCLAIMER,
            payload: {
                showDescriptionDisclaimerControl
            }
        };
    },
    translateDescription(locale) {
        return {
            type: ACTIONS.TRANSLATE_PROPERTY_DESCRIPTION,
            payload: {
                locale
            }
        };
    },
    primaryActionRendered() {
        return {
            type: ACTIONS.PRIMARY_ACTION_RENDERED
        };
    },
    localizeDescriptionFailure(showAlert) {
        return {
            type: ACTIONS.TRANSLATE_PROPERTY_DESCRIPTION_FAILURE,
            payload: {
                showAlert
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
